
const FMG_DATA = [
  {
    id:'n1',
    icon:'🙅',
    title:'Picky Eating',
    body:'Extreme food refusal, limited variety, texture sensitivity, mealtime meltdowns. We identify the root cause — sensory, behavioural or environmental — and fix the system, not the child.',
    color:'#3D6B53',
    bg:'#EAF2EE'
  },
  {
    id:'n2',
    icon:'⚖️',
    title:'Weight Gain & Growth',
    body:'Underweight children, slow growth curves, low muscle development. We build calorie-dense, nutrient-rich meal structures tailored to your child\'s age, activity and growth trajectory.',
    color:'#9A6A0A',
    bg:'#FFF4DC'
  },
  {
    id:'n3',
    icon:'🥗',
    title:'Proper Nutrition',
    body:'Eating, but not eating well. Iron deficiency, Vitamin D, calcium gaps — we fill them with real food first. Supplements only where truly needed.',
    color:'#3D6B53',
    bg:'#EAF2EE'
  },
  {
    id:'n4',
    icon:'🍟',
    title:'Junk Food Overload',
    body:'Ultra-processed everything, sugar dependency. We gradually reshape the palate and environment so real food becomes the preference — not the battle — over time.',
    color:'#9A6A0A',
    bg:'#FFF4DC'
  },
  {
    id:'n5',
    icon:'🧠',
    title:'Focus & Energy Issues',
    body:'Sluggish mornings, poor concentration — often a nutrition issue in disguise. We target blood sugar balance, omega-3s, iron and meal timing to bring your child\'s energy back.',
    color:'#3D6B53',
    bg:'#EAF2EE'
  },
  {
    id:'n6',
    icon:'🏷️',
    title:'Product Guidance',
    body:'Which biscuit is real nutrition? Which health drink has more additives than nutrients? We decode every label and tell you the truth — no brand bias, no sponsored recommendations.',
    color:'#C0204A',
    bg:'#FDE8EF'
  }
];

window.showDetail = function(idx){

  const d = FMG_DATA[idx];

  const icon = document.getElementById('dp-icon');
  const title = document.getElementById('dp-title');
  const body = document.getElementById('dp-body');
  const panel = document.getElementById('detail-panel');

  if(!icon || !title || !body || !panel) return;

  icon.textContent = d.icon;

  title.textContent = d.title;
  title.style.color = d.color;

  body.textContent = d.body;
  body.style.color = '#6B6B6B';
  body.style.fontStyle = 'normal';

  panel.style.borderLeft = `4px solid ${d.color}`;
  panel.style.background = d.bg;

  document.querySelectorAll('.node-group').forEach(g => {
    g.classList.remove('active');
  });

  const activeNode = document.getElementById(d.id);

  if(activeNode){
    activeNode.classList.add('active');
  }
}

// MOBILE CARDS
const fmgGrid = document.getElementById('cards-grid');

if(fmgGrid){

  FMG_DATA.forEach(d => {

    const card = document.createElement('div');

    card.style.cssText = `
      background:${d.bg};
      border-radius:14px;
      padding:20px 16px;
      text-align:center;
      border:1.5px solid ${d.bg === '#FDE8EF' ? d.color : 'transparent'};
    `;

    card.innerHTML = `
      <div style="font-size:28px;margin-bottom:10px;">
        ${d.icon}
      </div>

      <div style="
        font-family:'Wimberly';
        font-size:14px;
        font-weight:700;
        color:${d.color};
        margin-bottom:6px;
      ">
        ${d.title}
      </div>

      <div style="
        font-size:12px;
        color:#6B6B6B;
        line-height:1.6;
      ">
        ${d.body}
      </div>
    `;

    fmgGrid.appendChild(card);

  });

}

document.addEventListener('DOMContentLoaded', function(){
  showDetail(0);
});